import React, { createContext, useEffect, useMemo, useState } from "react";
import ContactDashBoardHeader from "../microcomponents/ContactDashBoardHeader";
import ContactLeftPanel from "./ContactLeftPanel";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getContactInformation,
  TRIGGER_USER_PROFILE_REQUEST,
} from "app/redux/features/contactById";
import { getObjectFromLocalStore } from "app/utils/localStore";

export const ContactProfileDetailsContext = createContext<any>({});
function ContactLayout() {
  const {
    agentContactSuccess,
    agentContactProfilePictureUploadSuccess,
    agentContactBasicInfoEditSuccess,
  } = useSelector(getContactInformation);

  const [isOpen, setIsOpen] = useState(true);

  const userAccess = getObjectFromLocalStore("useraccess");
  const dispatch = useDispatch();

  const contactProfilePic = agentContactSuccess?.data?.profilePicture ?? "";
  const contactFirstName = agentContactSuccess?.data?.firstName ?? "";
  const contactLastName = agentContactSuccess?.data?.lastName ?? "";
  const agentProfilePic = agentContactSuccess?.data?.agent?.profilePicture ?? "";
  const agentName = agentContactSuccess?.data?.agent?.name ?? "";
  const agentEmail = agentContactSuccess?.data?.agent?.email ?? "";
  const agentPhone = `${agentContactSuccess?.data?.agent?.contact?.countryCode}, ${agentContactSuccess?.data?.agent?.contact?.phoneNumber} `;

  const contextValue = useMemo(
    () => ({
      contactProfilePic,
      contactFirstName,
      contactLastName,
      agentProfilePic,
      agentName,
      agentEmail,
      agentPhone,
      isOpen,
      setIsOpen,
    }),
    [
      agentContactSuccess,
      contactFirstName,
      contactLastName,
      agentProfilePic,
      agentName,
      agentEmail,
      agentPhone,
      isOpen,
      setIsOpen,
    ],
  );

  useEffect(() => {
    if (userAccess?.userType === "contact") {
      dispatch({
        type: TRIGGER_USER_PROFILE_REQUEST,
        payload: {
          address: "contact",
        },
      });
    }
  }, [agentContactProfilePictureUploadSuccess?.data, agentContactBasicInfoEditSuccess?.data]);
  return (
    <ContactProfileDetailsContext.Provider value={contextValue}>
      <ContactDashBoardHeader />
      <div className="h-full flex">
        <ContactLeftPanel />
        <div className="flex-1 overflow-auto h-screen">
          <Outlet />
        </div>
      </div>
    </ContactProfileDetailsContext.Provider>
  );
}

export default ContactLayout;
